var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"down_icon",staticStyle:{"display":"flex","justify-content":"center"},on:{"click":_vm.handleClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"max-icon",attrs:{"src":require("@/assets/svg/down-max2.svg")}})])
}]

export { render, staticRenderFns }